import { InputLabel, Select, SelectProps, Stack, Tooltip } from '@mui/material';
import * as React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import variable from '../style/variable';

interface IDropDownProps extends SelectProps {
    inputLabel?: string;
    children: React.ReactNode;
    textTooltip?: string;
    required?: boolean;
}

const DropDown = (props: IDropDownProps) => (
    <Stack padding={'0.3rem 0rem'} spacing={0.5}>
        {props.textTooltip ? (
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                    {props.inputLabel}
                </InputLabel>
                <Tooltip title={props.textTooltip}>
                    <InfoIcon style={{ fill: variable.green }} fontSize='medium' />
                </Tooltip>
            </Stack>
        ) : (
            <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                {props.inputLabel}
            </InputLabel>
        )}
        <Select {...props}>{props.children}</Select>
    </Stack>
);

export default DropDown;
